import VOD from './vod/index';
import YouTube from './youtube/index';
import Vimeo from './vimeo/index';
import Facebook from './facebook/index';

const adaptersList = {
  VOD,
  YouTube,
  Vimeo,
  Facebook,
};

export default adaptersList;



// WEBPACK FOOTER //
// ./src/transport/adapters/index.js